export default __webpack_public_path__ + "static/g201-2c9c544c380887270b74ee9e964c7732.jpg";